module.exports = __webpack_public_path__ + "img/GardenofGamba.a642f90d.png";